import {useLocation, useParams, useSearchParams} from 'react-router-dom';
import {ROUTES} from '@/config/routesConstants';

type ContentSubmissionLinkParams = {
  parentContentSubmissionId?: string;
  contentSubmissionId?: string;
  additionalSearchParams?: Record<string, string>;
};

function useContentSubmissionLink() {
  const [searchParams] = useSearchParams();
  const {campaignId} = useParams<{campaignId: string}>();
  const {pathname} = useLocation();

  // Derive the assets base path from the current URL context
  const isOffPlatform = pathname.startsWith(ROUTES.OFF_PLATFORM_REVIEW);
  const basePath = isOffPlatform
    ? `${ROUTES.OFF_PLATFORM_REVIEW}/${campaignId}`
    : `${ROUTES.CAMPAIGNS_V2}/${campaignId}/assets`;

  return (params: ContentSubmissionLinkParams): string => {
    const parts: string[] = [basePath];

    if (params.parentContentSubmissionId) {
      parts.push('mixed-media', params.parentContentSubmissionId);
    }

    if (params.contentSubmissionId) {
      parts.push(params.contentSubmissionId);
    }

    // Preserve all current search params
    const mergedParams = new URLSearchParams(searchParams);

    // Merge additional search params
    if (params.additionalSearchParams) {
      Object.entries(params.additionalSearchParams).forEach(([key, value]) => {
        mergedParams.set(key, value);
      });
    }

    const path = parts.join('/');
    const queryString = mergedParams.toString();

    return queryString ? `${path}?${queryString}` : path;
  };
}

export default useContentSubmissionLink;
